export default __webpack_public_path__ + "static/47-4ecaaecd35620a2768b079eebdd742e9.gif";